import axios from 'axios';

// The shared client owns the `/api` prefix. Callers use endpoint-relative URLs.
const apiClient = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL || ''}/api` });

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const body = error.response?.data;
    if (status === 402 && (body?.code === 'TRIAL_EXPIRED' || body?.detail?.code === 'TRIAL_EXPIRED')) {
      if (window.location.pathname !== '/trial-expired') window.location.assign('/trial-expired');
    }
    return Promise.reject(error);
  },
);

export default apiClient;
